import {
    IExecutionOptions,
    IQueryContext,
    IQueryKeyValue,
} from '../../models/commonTypes';
import { query } from '@kurtosys/ksys-app-template';

export default function getQueryResults(
    queryContext: IQueryContext,
    queries: IQueryKeyValue,
    culture?: string,
    inputs?: object
) {
    if (queryContext && queries) {
        const executionOptions: IExecutionOptions = {
            culture,
            inputs,
            fallbackCulture: 'en-GB',
            context: queryContext,
        };
        const result = query.Query.convertQueryKeyValue(
            queries,
            executionOptions
        );
        return result;
    }
    return {};
}



// WEBPACK FOOTER //
// ./src/utils/query/getQueryResults.ts